import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

import Logo from '../Logo'
import Container from '../Container'

const Footer = ({ classNames, siteTitle, children }) => (
  <footer className={cn('Footer', {}, classNames)}>
    <Container>
      <div className="Footer__content">
        <Logo alt={siteTitle} />
        <div className="Footer__links">{children}</div>
      </div>
    </Container>
  </footer>
)

Footer.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  siteTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default Footer
